// this is broken out into it's own JS file because 
// it needs to be implemented with a script defer tag 
// the rest of the application.js file doesn't work well with a defer tag
// for all of our legacy stuff (e.g. jquery included on the page or loaded externally with RJS)
import Alpine from 'alpinejs'
import Collapse from '@alpinejs/collapse'

Alpine.plugin(Collapse)
Alpine.start()
window.Alpine = Alpine
